import { ContextMenuButton, Icon, Text } from "@seneca/senekit";

type Props = {
  isEnabled: boolean;
  toggle: () => void;
};
export default function DarkModeToggle({ isEnabled, toggle }: Props) {
  return (
    <ContextMenuButton
      onClick={e => {
        e.stopPropagation();
        toggle();
      }}
    >
      {{
        icon: (
          <Icon
            iconName={isEnabled ? "sun" : "moon"}
            accessibilityLabel={null}
            tone="neutral"
          />
        ),
        text: <Text tone="neutral">{isEnabled ? "Light" : "Dark"} mode</Text>
      }}
    </ContextMenuButton>
  );
}
